<template>
  <div v-if="showPopup" class="popup" >
   
    <div class="popup-content" styles="background-color: #AB1F08 !important; 
                overflow-y: scroll; 
                max-width: 1000px; 
                margin: 0 auto;">
      <div class="button-close-position">
          <button class="button-close"
              @click="closePopup">
              X
          </button>
      </div>
      <div class="ipad-display">
        <img v-bind:src="'images/mpower-new/popup/iPad.png'" class="popup-ipad">
      </div>
      <div class="mobile-display">
        <img v-bind:src="'images/mpower-new/popup/mobile.png'" class="popup-mobile">
      </div>   
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        showPopup: true,
      };
    },
    methods: {
      closePopup() {
        this.showPopup = false;
      },
    },
  };
</script>
  
<style scoped>
  .popup {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .popup-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  }
  .popup-mobile{
    height: auto;
    width: 100vw;
  }
  .popup-ipad{
    height: auto;
    width: 70vw;
  }

  .button-close-position{
    position: absolute;
    z-index: 1;
    top: 0px;
    right: 0px;
  }
  .button-close {
    background-color: #bf271b;
    color: white;
    height: 30px;
    width: 30px;
    border-radius: 16px;
    cursor: pointer;
    font-weight: bold;
    margin-right: 15px;
    margin-top: 15px;
  }
</style>
  